import { motion } from "framer-motion";
import { SectionHeading, Reveal } from "./Reveal";
import { PROCESS_STEPS } from "../../data/content";

export const Process = () => (
    <section id="process" data-testid="process-section" className="relative bg-ivory py-28 lg:py-36">
        <div className="mx-auto max-w-7xl px-6 lg:px-10">
            <SectionHeading
                eyebrow="How We Work"
                title="The Signature Process"
                script="from first hello to final toast"
            />

            <div className="relative mt-20 hidden lg:block">
                <div className="absolute left-0 right-0 top-7 h-px bg-gold/20" />
                <motion.div
                    className="absolute left-0 right-0 top-7 h-px origin-left bg-gold"
                    initial={{ scaleX: 0 }}
                    whileInView={{ scaleX: 1 }}
                    viewport={{ once: true, margin: "-100px" }}
                    transition={{ duration: 2, ease: [0.22, 1, 0.36, 1] }}
                />
                <div className="relative grid grid-cols-4 gap-10">
                    {PROCESS_STEPS.map((step, i) => (
                        <motion.div
                            key={step.num}
                            data-testid={`process-step-${step.title.toLowerCase()}`}
                            initial={{ opacity: 0, y: 26 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true, margin: "-100px" }}
                            transition={{ duration: 0.7, delay: 0.35 + i * 0.35, ease: [0.22, 1, 0.36, 1] }}
                            className="flex flex-col items-center text-center"
                        >
                            <div className="flex h-14 w-14 items-center justify-center rounded-full border border-gold bg-ivory shadow-[0_0_0_8px_rgba(251,248,242,1)]">
                                <span className="font-serif text-sm tracking-widest text-gold">{step.num}</span>
                            </div>
                            <h3 className="mt-6 font-serif text-2xl tracking-wide text-emerald">{step.title}</h3>
                            <p className="mt-3 text-sm leading-relaxed text-emerald-light/80">{step.text}</p>
                        </motion.div>
                    ))}
                </div>
            </div>

            <div className="relative mt-16 lg:hidden">
                <motion.div
                    className="absolute bottom-6 left-7 top-6 w-px origin-top bg-gold/60"
                    initial={{ scaleY: 0 }}
                    whileInView={{ scaleY: 1 }}
                    viewport={{ once: true, margin: "-80px" }}
                    transition={{ duration: 1.6, ease: [0.22, 1, 0.36, 1] }}
                />
                <div className="flex flex-col gap-12">
                    {PROCESS_STEPS.map((step, i) => (
                        <Reveal key={step.num} delay={i * 0.12}>
                            <div className="relative flex gap-8 pl-2" data-testid={`process-step-mobile-${step.title.toLowerCase()}`}>
                                <div className="z-10 flex h-12 w-12 shrink-0 items-center justify-center rounded-full border border-gold bg-ivory">
                                    <span className="font-serif text-xs tracking-widest text-gold">{step.num}</span>
                                </div>
                                <div>
                                    <h3 className="font-serif text-2xl tracking-wide text-emerald">{step.title}</h3>
                                    <p className="mt-2 text-sm leading-relaxed text-emerald-light/80">{step.text}</p>
                                </div>
                            </div>
                        </Reveal>
                    ))}
                </div>
            </div>
        </div>
    </section>
);
